import { gql } from '@apollo/client';
import type { UserPath_UserFragment } from '../../graphql/generated/graphqlTypes';
import entityPath from './entityPath';

const USER_PATH_USER = gql`
  fragment userPath_user on PublicUserFields {
    id
    name
  }
`;

export default function userPath(user: UserPath_UserFragment) {
  return `/users/${entityPath(user.name, user.id)}`;
}

userPath.fragments = { user: USER_PATH_USER };
